<template>
  <g
    id="Front_Headlight-2"
    v-on:click="changeSeverity('leftFrontHeadLight')"
    :class="severityClass"
  >
    <g>
      <ellipse class="cls-272" cx="431.65" cy="129.1" rx="3.84" ry="10.83" />
      <ellipse class="cls-233" cx="431.58" cy="129.1" rx="3.73" ry="10.72" />
      <ellipse class="cls-138" cx="431.52" cy="129.1" rx="3.62" ry="10.61" />
      <ellipse class="cls-277" cx="431.46" cy="129.1" rx="3.51" ry="10.5" />
      <ellipse class="cls-349" cx="431.4" cy="129.1" rx="3.4" ry="10.39" />
      <ellipse class="cls-314" cx="431.34" cy="129.1" rx="3.29" ry="10.28" />
      <ellipse class="cls-344" cx="431.28" cy="129.1" rx="3.18" ry="10.17" />
      <ellipse class="cls-377" cx="431.21" cy="129.1" rx="3.07" ry="10.06" />
      <ellipse class="cls-401" cx="431.15" cy="129.1" rx="2.96" ry="9.95" />
      <ellipse class="cls-35" cx="431.09" cy="129.1" rx="2.85" ry="9.84" />
    </g>
    <path
      class="cls-273"
      d="M434.91,134.77c-.54-.39-1.13-.71-1.6-.87-.14-.05-.22-.18-.22-.32v-14.5c-.45-.51-.94-.8-1.45-.8-2.12,0-3.84,4.85-3.84,10.83s1.72,10.83,3.84,10.83c1.38,0,2.59-2.06,3.27-5.16Z"
    />
    <path
      class="cls-884"
      d="M430.66,141.29h6.62c.39,0,.66-.4,.51-.76-.75-1.85-2.88-6.42-5.65-6.42l-1.48,7.18Z"
    />
    <path
      class="cls-882"
      d="M425.83,116.42h4.2c1.17,0,2.11,.95,2.11,2.11v21.14c0,1.17-.95,2.11-2.11,2.11h-4.2v-25.37h0Z"
    />
  </g>
</template>
<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
